module.exports = __webpack_public_path__ + "media/images/home-latinadirtygirl-2a41383d331f92ef5b037098b52a986c.jpg";